// src/constants.jsx

export const ADMIN_ID = 123;
